<template>

  <div id="wrapperCostCompareForm" class="single_layout">

    <div class="grid grid-cols-1 lg:gap-4 gap-2">
      <InputGroup
        ref="firstName"
        name="firstName"
        label="First Name"
        rules="required"
        @inputChanged="onInputChange"
      />
    </div>

    <div class="grid grid-cols-1 lg:gap-4 gap-2">
      <InputGroup
        ref="lastName"
        name="lastName"
        label="Last Name"
        rules="required"
        @inputChanged="onInputChange"
      />
    </div>

    <div class="grid grid-cols-1 lg:gap-4 gap-2">
      <InputGroup
        ref="company"
        name="company"
        label="Company Name"
        rules="required"
        @inputChanged="onInputChange"
      />
    </div>

    <div class="grid grid-cols-1 lg:gap-4 gap-2">
      <InputGroup
        ref="email"
        name="email"
        label="Email"
        rules="required|email"
        @inputChanged="onInputChange"
      />
    </div>

    <div class="grid grid-cols-1 lg:gap-4 gap-2">
      <InputPhone
        ref="phone"
        name="phone"
        label="Phone"
        rules="required|phone"
        @inputChanged="onInputChange"
      />
    </div>

    <div class="grid grid-cols-1 lg:gap-4 gap-2">
      <InputGroup
        ref="currentPaymentProcessor"
        name="currentPaymentProcessor"
        rules="required"
        label="Who is you current processor (Enter NA, if none)?"
        @inputChanged="onInputChange"
      />
    </div>

    <div class="grid grid-cols-1 lg:gap-4 gap-2">
      <button
        :class="buttonStyle"
        @click="handleSubmitClick"
      >
        Submit Form
      </button>
    </div>

  </div>
</template>

<script>

import InputGroup from '@src/components/input-group.vue';
import InputPhone from '@src/components/input-phone.vue';

export default {
  name: 'CostCompareLayoutSingle',
  props: {
    onInputChange: { type: Function, required: true },
    onSubmit: { type: Function, required: true },
    onError: { type: Function, required: true },
    buttonStyle: { type: String, required: false, default: 'btn_submit clientpay' },
  },
  components: {
    InputGroup,
    InputPhone,
  },
  methods: {
    handleSubmitClick(event) {
      this.$props.onSubmit(event, this.$refs);
    },
  },
};
</script>
